/**
 * 市场动态 store
 */

import axios from "../../utils/axios";

let state = {

};

let getters = {

};

let mutations = {

};

let actions = {
  dynamic(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/price/commodity?month=${payload.month}&name=${payload.productName}`)
      .then(res => {
        resolve(res.data.data);
      })
      .catch(error => {
        console.log(error);
        reject();
      });
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}